import React, { useState } from "react";
import PropTypes from "prop-types";

const DqiSetup = ({ onExecute, disabled, errors }) => {
  const [jobId, setJobId] = useState("");

  const createCompany = () => {
    onExecute({ jobId });
  };

  const updateJobId = (evt) => {
    setJobId(evt.target.value);
  };

  return (
    <div className="card" style={{ marginBottom: "24px" }}>
      <div className="card-body">
        <h3 className="card-title">3. Create DQI Company</h3>
        <div className="card-text">
          <p>
            Once the Shop Floor Company has finished being created in
            Step&nbsp;2, paste the Job ID from the log on the right into the
            field below.
          </p>
          <div className="form-group">
            <div className="col-xs-3">
              <label htmlFor="job-id">
                Job ID<span className="text-danger">*</span>
              </label>
              <input
                type="number"
                className="form-control"
                id="job-id"
                data-testid="job-id"
                placeholder="ID of Job in Shop Floor"
                onChange={updateJobId}
              />
              <span id="demo-date-errors" className="text-danger">
                {errors.jobId}
              </span>
            </div>
          </div>

          <input
            type="button"
            value="Create DQI Company"
            id="create_dqi_company_button"
            className="btn btn-primary"
            onClick={createCompany}
            disabled={disabled}
          />
        </div>
      </div>
    </div>
  );
};

DqiSetup.propTypes = {
  onExecute: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
  errors: PropTypes.object.isRequired,
};

export default DqiSetup;
